import * as React from "react";

import * as R from "ramda";

import {
  setNodeValueByUIDAndKey,
} from "../../src/doc_helpers";

import DocInlineText from "./InlineText";

interface DocImageProps extends ImageNode, EveryNodeArgs {
  imagingTypes?: Array<ImagingType>;
  inGallery?: boolean;
}

interface DocImageState {
  imageModalOn: boolean;
}

export default class DocImage extends React.Component<DocImageProps, DocImageState> {
  state = {
    imageModalOn: false,
  };

  onImageEditClick() {
    const {
      displayState,
      editState,
      uid,
    } = this.props;

    if (editState.isEditor && editState.isEditing) {
      displayState.setOpenMenu({name: "MEDIA_MENU", uid: uid, mediaType: "image"});
    }
  }

  toggleImageModal() {
    this.setState({imageModalOn: !this.state.imageModalOn});
  }

  handleImagingTypeChange(e: React.ChangeEvent<HTMLSelectElement>) {
    const {
      uid,
      currentVersion,
    } = this.props;


    currentVersion._actions.modifyEditJSON((json) =>
      setNodeValueByUIDAndKey(json, uid, "imagingType", e.target.value),
    );
  }

  render() {
    const {
      imageModalOn,
    } = this.state;

    const {
      currentVersion,
      editState,
      imagingType,
      imagingTypes,
      inGallery,
      source,
      title,
      uid,
      uri,
    } = this.props;

    if (!("aws_folder_url" in currentVersion)) { return; }

    const imageURL = source === "reeldx" ? `${currentVersion.aws_folder_url}/images/${uri}` : `${currentVersion.aws_folder_url}/compressed/images/${uri}`;

    let imageModal;
    if (imageModalOn) {
      imageModal = (
        <div className="image-modal-outter" onClick={this.toggleImageModal.bind(this)}>
          <div className="image-modal-inner">
            <img src={imageURL} alt={title}/>
            <i className="fa fa-compress doc-image-compress-button bg-sky-500" />
          </div>
        </div>
      );
    }

    const image = (
      <figure className="doc-image">
        <div onClick={this.toggleImageModal.bind(this)}>
          <img src={imageURL} alt={title}/>
          <i className="fa fa-expand doc-image-expand-button bg-sky-500" />
        </div>
        <figcaption>
          <DocInlineText content={title} uid={uid} contentKey="title" editState={editState}/>
        </figcaption>
        {imageModal}
        {editState.isEditor && editState.isEditing && (
        <>
          <i className="fa fa-cog bg-sky-600 p-2 doc-media-edit-button" onClick={this.onImageEditClick.bind(this)}> Edit Image</i>
          {imagingTypes && R.length(imagingTypes) > 0 && (
          <select value={imagingType} onChange={this.handleImagingTypeChange.bind(this)} className="tag-select">
            <option value="">Select Imaging Type</option>
            {imagingTypes.map((t) => <option value={t} key={t}>{t}</option>)}
          </select>
          )}
        </>
       )}
      </figure>
    );

    if (inGallery) {
      return image;
    } else {
      return (
        <div className="doc-image-single">
          {image}
        </div>
      );
    }
  }
}
